export default __webpack_public_path__ + "static/media/speedy_coin_video.45e72b74.mov";